/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApplicationPreviewResponse,
  GetByOrganisationIdAndTypesParams,
  InformationGroupDto,
  StripeCustomerDetailsResponse,
  StripeSessionDetails,
  UpdateInformationRequestDto,
  UploadInformationRequestDocumentPayload,
  UserProfileSlim,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiApplicationControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name CreateStripeSession
   * @request POST:/api/v2/application/stripe-session
   */
  createStripeSession = (params: RequestParams = {}) =>
    this.http.request<StripeSessionDetails, any>({
      path: `/v2/application/stripe-session`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static createStripeSessionPath = '/v2/application/stripe-session'
  static createStripeSessionMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name UploadInformationRequestDocument
   * @request POST:/api/v2/application/information-requests/{requestId}/document
   */
  uploadInformationRequestDocument = (
    requestId: string,
    data: UploadInformationRequestDocumentPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<InformationGroupDto, any>({
      path: `/v2/application/information-requests/${requestId}/document`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadInformationRequestDocumentPath =
    '/v2/application/information-requests/${requestId}/document'
  static uploadInformationRequestDocumentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name DeleteInformationRequestDocument
   * @request DELETE:/api/v2/application/information-requests/{requestId}/document
   */
  deleteInformationRequestDocument = (requestId: string, params: RequestParams = {}) =>
    this.http.request<InformationGroupDto, any>({
      path: `/v2/application/information-requests/${requestId}/document`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static deleteInformationRequestDocumentPath =
    '/v2/application/information-requests/${requestId}/document'
  static deleteInformationRequestDocumentMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name SubmitInformationRequestResponses
   * @request POST:/api/v2/application/information-requests/submit
   */
  submitInformationRequestResponses = (params: RequestParams = {}) =>
    this.http.request<InformationGroupDto[], any>({
      path: `/v2/application/information-requests/submit`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static submitInformationRequestResponsesPath = '/v2/application/information-requests/submit'
  static submitInformationRequestResponsesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name UpdateInformationRequestValue
   * @request PATCH:/api/v2/application/information-requests/{requestId}
   */
  updateInformationRequestValue = (
    requestId: string,
    data: UpdateInformationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<InformationGroupDto, any>({
      path: `/v2/application/information-requests/${requestId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateInformationRequestValuePath = '/v2/application/information-requests/${requestId}'
  static updateInformationRequestValueMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name GetStripeCustomerDetails
   * @request GET:/api/v2/application/stripe/customer
   */
  getStripeCustomerDetails = (params: RequestParams = {}) =>
    this.http.request<StripeCustomerDetailsResponse, any>({
      path: `/v2/application/stripe/customer`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getStripeCustomerDetailsPath = '/v2/application/stripe/customer'
  static getStripeCustomerDetailsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name GetInformationRequests
   * @request GET:/api/v2/application/information-requests
   */
  getInformationRequests = (params: RequestParams = {}) =>
    this.http.request<InformationGroupDto[], any>({
      path: `/v2/application/information-requests`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInformationRequestsPath = '/v2/application/information-requests'
  static getInformationRequestsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name GetByOrganisationIdAndTypes
   * @request GET:/api/v2/application/by-organisation/with-types
   */
  getByOrganisationIdAndTypes = (
    query: GetByOrganisationIdAndTypesParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationPreviewResponse[], any>({
      path: `/v2/application/by-organisation/with-types`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getByOrganisationIdAndTypesPath = '/v2/application/by-organisation/with-types'
  static getByOrganisationIdAndTypesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-application-controller-v-2
   * @name GetApplicantByApplicationId
   * @request GET:/api/v2/application/applicant
   */
  getApplicantByApplicationId = (params: RequestParams = {}) =>
    this.http.request<UserProfileSlim, any>({
      path: `/v2/application/applicant`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getApplicantByApplicationIdPath = '/v2/application/applicant'
  static getApplicantByApplicationIdMethod = 'GET'
}
